import axios, { BASE_URL } from "../axios";
import BaseModel from "./baseModel";

export default class DataCollectionModel extends BaseModel {
  static endPoint = "data/";

  static getWithQuery(query) {
    return axios.get(BASE_URL + this.endPoint + query);
  }

  static approve(id) {
    return axios.post(BASE_URL + this.endPoint + "approve/" + id);
  }
}
